import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from 'react-redux';
import { useTheme, ThemeProvider, Container, Typography, useMediaQuery, Box, TextField } from "@mui/material";
import { Form, Input, Button, message, Select } from "antd";
import { useNavigate, useParams } from "react-router-dom";

import Dragger from "antd/es/upload/Dragger";
import { UploadOutlined } from "@ant-design/icons";
import useSelection from "antd/es/table/hooks/useSelection";


import SearchIcon from "@mui/icons-material/Search";
import Sidebars from "../../Components/Sidebar/sidebar";
import '../../css/vehicles.css';
import SearchBar from "../../Components/SearchBar";
import { BorderBottom } from "@mui/icons-material";
import appColors from "../../config/appColors";
import { postRequest } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import VehicleView from "../../Components/VehicleView";
import { selectStyle } from "../../css/styles";
const { Option } = Select;


const NewInvoice = () => {


    const ids = useParams();

    console.log('ids', ids)
    const theme = useTheme();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Adjust breakpoint as needed
    const user = useSelector((state) => state.authReducer.user);
    const [form] = Form.useForm();

    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState({});
    const [vehicles, setVehicles] = useState([]);
    const [selectedVehicle, setSelectedVehicle] = useState({});
    const [startDate, setStartDate] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [endDate, setEndDate] = useState();

    const [invoiceAmount, setInvoiceAmount] = useState('');
    const [invoiceStatus, setInvoiceStatus] = useState('pending');
    const [dueDate, setDueDate] = useState(false);



    const getClientsAndVehicles = async () => {

        const onSuccess = (res) => {
            console.log('res', res.data)
            if (ids.cust_id && res.data?.clients?.length) {
                setSelectedClient(res.data?.clients[0]);
            }
            else setClients(res.data?.clients)
            if (ids.veh_id && res.data?.vehicles?.length) {
                setSelectedVehicle(res.data?.vehicles[0]);
            }
            else setVehicles(res.data?.vehicles)

        }

        const onError = (err) => {
            console.log('err', err);
        }

        dispatch(setLoader(true));
        const body = {
            token:  user?.token,
            cust_id: ids.cust_id ?? null,
            veh_id: ids.veh_id ?? null,
            invoice: true
            // user?.token
        }

        await postRequest(body, apiRoutes.getClientsAndVehicles, onSuccess, onError)

    }

    const onFinish = async () => {

        if (!selectedClient?._id) return message.error('Please select a client');
        if (!selectedVehicle?.veh_id) return message.error('Please select a vehicle');
        if (!invoiceAmount) return message.error('Please enter invoice amount');
        if (!invoiceStatus) return message.error('Please select invoice status');
        if (!dueDate && invoiceStatus == 'pending') return message.error('Please enter due date');

        const body = {
            token: user?.token,
            cust_id: selectedClient?._id,
            veh_id: selectedVehicle?.veh_id,
            inv_amount: invoiceAmount,
            status: invoiceStatus,
            due_date: dueDate
        }
        if (!dueDate) delete body.due_date;
        // console.log('body',body);
        // return;
        const onSuccess = (res) => {
            console.log('res', res.data)
            message.success('Invoice added successfully');
            navigate('/invoices');
        }
        const onError = (err) => {
            console.log('err', err)
            message.error(err?.data?.error);
        }
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.addInvoice, onSuccess, onError);



    }

    const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
    };

    useEffect(() => {
        getClientsAndVehicles();
    }, [])


    return (
        <>
            <ThemeProvider theme={theme}>
                <div style={{ display: 'flex', }}>
                    <Sidebars />

                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 20, width: "75%" }} >
                        <span className={`headertext ${isSmallScreen ? 'small-screen' : ''}`}>
                            Add New Invoice
                        </span>
                        <Form
                            style={{ width: "100%", }}
                            layout="vertical"
                            form={form}
                            // onFinish={onFinish}
                            // onFinishFailed={onFinishFailed}
                            initialValues={{
                                clientName: selectedClient?.name,
                                clientEmail: selectedClient?.email,
                            }}
                        >
                            <div style={{ display: 'flex', flexDirection: 'column', width: "100%", borderRadius: 10, backgroundColor: appColors.white, marginTop: 10, paddingBottom: 10 }}>
                                <div style={{ width: "100%", height: 45, borderTopRightRadius: 10, borderTopLeftRadius: 10, backgroundColor: appColors.primary }}>
                                    <Typography style={{ color: appColors.white, fontSize: 16, fontWeight: 600, marginLeft: 10, marginTop: 10 }}>Client Information</Typography>
                                </div>
                                <div style={{
                                    display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: "98.5%",
                                    justifyContent: 'space-between', alignSelf: 'center', marginTop: 10,
                                }} >
                                    <Form.Item
                                        style={selectStyle}
                                        name="clientName"
                                    >
                                        <Typography style={labelStyle}>Name</Typography>
                                        <Select
                                            disabled={ids.cust_id}
                                            value={selectedClient?.name}
                                            className="textInput"
                                            placeholder="Select customer"
                                            onChange={(value) => {
                                                let client = clients?.find((v, i) => v._id == value);
                                                setSelectedClient(client);
                                            }}
                                        >
                                            {
                                                clients?.length && clients?.map((v, i) => {
                                                    return (
                                                        <>
                                                            <Option value={v._id}>{v.name}</Option>
                                                        </>
                                                    )
                                                })
                                            }
                                            <Option value={selectedClient._id}>{selectedClient.name}</Option>

                                        </Select>
                                    </Form.Item>
                                    <Form.Item
                                        name="clientEmail"
                                    >
                                        <Typography style={labelStyle}>Email</Typography>
                                        <Input
                                            disabled={true}
                                            className="textInput"
                                            value={selectedClient?.email}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="clientPhone"
                                    >
                                        <Typography style={labelStyle}>Phone</Typography>
                                        <Input
                                            disabled={true}
                                            className="textInput"
                                            value={selectedClient?.phone}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="clientLicense"
                                    >
                                        <Typography style={labelStyle}>License number</Typography>
                                        <Input
                                            disabled={true}
                                            className="textInput"
                                            value={selectedClient?.license_number}
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                            {/* CONTRACT INFORMATION */}
                            <div style={{ display: 'flex', flexDirection: 'column', width: "100%", borderRadius: 10, backgroundColor: appColors.white, marginTop: 20, paddingBottom: 10 }}>
                                <div style={{ width: "100%", height: 45, borderTopRightRadius: 10, borderTopLeftRadius: 10, backgroundColor: appColors.primary }}>
                                    <Typography style={{ color: appColors.white, fontSize: 16, fontWeight: 600, marginLeft: 10, marginTop: 10 }}>Invoice Information</Typography>
                                </div>
                                <div style={{
                                    display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: "98.5%",
                                    justifyContent: 'space-between', alignSelf: 'center', marginTop: 10,
                                }} >
                                    <Form.Item
                                        style={selectStyle}
                                        name="clientName"
                                    >
                                        <Typography style={labelStyle}>Vehicle name</Typography>
                                        <Select
                                            disabled={ids.veh_id}
                                            value={selectedVehicle?.veh_name}
                                            className="textInput"
                                            placeholder="Select vehicle"
                                            onChange={(value) => {
                                                let vehicle = vehicles?.find((v, i) => v.veh_id == value);
                                                setSelectedVehicle(vehicle);
                                                setInvoiceAmount(vehicle.rent)
                                            }}
                                        >
                                            {
                                                vehicles?.length && vehicles?.map((v, i) => {
                                                    return (
                                                        <>
                                                            <Option value={v.veh_id}>{v.veh_name}</Option>
                                                        </>
                                                    )
                                                })
                                            }
                                            <Option value={selectedVehicle.veh_id}>{selectedVehicle.veh_name}</Option>

                                        </Select>
                                    </Form.Item>
                                    <Form.Item
                                        name="rent"
                                    >
                                        <Typography style={labelStyle}>Invoice amount</Typography>
                                        <Input
                                            onChange={(e) => setInvoiceAmount(e.target.value)}
                                            className="textInput"
                                            value={invoiceAmount}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        style={selectStyle}
                                        name="clientName"
                                    >
                                        <Typography style={labelStyle}>Status</Typography>
                                        <Select
                                            // value={selectedVehicle?.veh_name}
                                            className="textInput"
                                            placeholder="Select Invoice status"
                                            onChange={(value) => {
                                                setInvoiceStatus(value)
                                            }}
                                        >
                                            <>
                                                <Option value={"paid"}>{"Paid"}</Option>
                                                <Option value={"pending"}>{"Pending"}</Option>
                                            </>
                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        name="due_date"
                                    >
                                        <Typography style={labelStyle}>Due date</Typography>
                                        <Input
                                            disabled={invoiceStatus == 'paid' ? true : false}
                                            onChange={(e) => setDueDate(e.target.value)}
                                            type="date"
                                            value={dueDate}
                                            className="textInput"
                                        />
                                    </Form.Item>


                                    <div style={{ width: 250 }}></div>


                                </div>
                            </div>

                            <Form.Item
                                style={{ textAlign: 'center', }}

                            >
                                <Button
                                    onClick={() => onFinish()}
                                    style={{
                                        height: 40, backgroundColor: appColors.primary, marginTop: 20,
                                        fontFamily: 'Poppins', fontSize: 14, fontWeight: 600, width: 200
                                    }}
                                    type="primary"
                                    htmlType="submit">

                                    Save
                                </Button>
                            </Form.Item>



                        </Form>
                    </div>

                </div>
            </ThemeProvider>
        </>
    )

}



const labelStyle = { color: appColors.black, fontSize: 14, fontFamily: 'Poppins', marginTop: 0 }

export default NewInvoice
